import Flickity from 'flickity';
import 'waypoints/lib/noframework.waypoints'




const carousel = {
  init (el) {
    
    class ElectudeFlickity extends Flickity {
      resize() {
        super.resize()
        this.selectedElement.classList.add('is-settled')
      }      
    }

    this.el = el
    this.slides = el.querySelectorAll('.carousel__slide')
    const interval = 6000
  

    const carousel = new ElectudeFlickity( el, {
      selectedAttraction: 1,
      friction: 1,
      prevNextButtons: false,
      draggable: false,
      cellSelector: '.carousel__slide',
      contain: true,
      pageDots: false,
      // adaptiveHeight: true,
      autoPlay: interval,
      on: {
        ready: () => this.slides[0].classList.add('is-settled'),
      },
    })

    carousel.on('select', () => {
      // console.log('select')
      if(this.timeout) clearTimeout(this.timeout)
      this.slides.forEach(slide => {
        slide.classList.remove('is-settled')
      })
      carousel.selectedElement.classList.add('is-settled')
      carousel.playPlayer()
    }) 



    carousel.on('settle', index => {
      
      this.slides[index].classList.add('is-settled')
      this.timeout = setTimeout(() => {
        carousel.selectedElement.classList.remove('is-settled')
      }, interval - 1000);
    })

    
    new Waypoint({
      element: el,
      handler: () => {
        if(el.classList.contains('carousel--animate')) return
        el.classList.add('carousel--animate')
      },
      offset: '75%',
    })
  },
}



export default {
  init () {
    const elements = document.querySelectorAll('.carousel')
    if(!elements.length) return

    elements.forEach(el => { 
      setTimeout(() => {
        carousel.init(el)          
      }, 500);
      
    })
  },
}